export const updateSomOfferMonitoring = ({ state, payload }) => {
	state.somOfferPriceOfferDb = payload.price_offer_data;
	state.somOfferMonitoring = payload.monitoring_data;
	state.somOfferMonitoringIndex.MONITORING_3 = state.somOfferMonitoring.length - 1;
	state.somOfferMonitoringIndex.MONITORING_2 = state.somOfferMonitoring.length - 2;
	state.somOfferMonitoringIndex.MONITORING_1 = state.somOfferMonitoring.length - 3;
};
